<ng-template dsClaimedTaskActions></ng-template>
